import { Navigate } from 'react-router-dom';
import { TermsConditions } from '.';
const routes = [
    {
        path: '/terms-and-conditions',
        element: <TermsConditions />,
        title: 'Terms and Conditions'
    }
]

export default routes;